import Mmenu from 'mmenu-js';
import 'mburger-webcomponent/dist/mburger/index';

export default function initializeMobileMenu() {

    new Mmenu( '#mobile-menu', {
        theme          : 'white',
    } );

    const linkElements = document.querySelectorAll('a.mm-navbar__title');

    linkElements.forEach(linkElement => {
        if (!linkElement.hasAttribute('href')) {
            linkElement.setAttribute('href', '#mm-1');
        }
    });

    linkElements.forEach(linkElement => {
        const newSpan = document.createElement('span');
        newSpan.innerHTML = '&nbsp;';
        linkElement.parentNode.insertBefore(newSpan, linkElement);
    });

}
